import React, { Suspense } from 'react';

const DelayedCampaignGoalSelectionStep =
  React.lazy(() => import(/* webpackChunkName: "campaign-goal-selection-step.async" */ './campaign-goal-selection-step')
    .then(({ CampaignGoalSelectionStepWithI18n }) => ({ default: CampaignGoalSelectionStepWithI18n })));

export const DelayedCampaignGoalSelectionStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedCampaignGoalSelectionStep />
  </Suspense>
);
